module.exports = __webpack_public_path__ + "static/media/congrat.441e0331.png";


//////////////////
// WEBPACK FOOTER
// ./src/NDF/Inspiration/img/congrat.png
// module id = 132
// module chunks = 0